import * as React from 'react';
import IconProps from '@shared/icons/types/IconProps';

function SvgFiGrid({ size, color, ...props }: IconProps): React.JSX.Element {
	const finalSize = size !== undefined ? size : 16;
	const finalColor = color !== undefined ? color : 'currentColor';
	return (
		<svg
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 33 32"
			width={finalSize}
			height={finalSize}
			{...props}
		>
			<g opacity={0.8}>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M3.16666 3.99999C3.16666 3.26361 3.76361 2.66666 4.49999 2.66666H13.8333C14.5697 2.66666 15.1667 3.26361 15.1667 3.99999V13.3333C15.1667 14.0697 14.5697 14.6667 13.8333 14.6667H4.49999C3.76361 14.6667 3.16666 14.0697 3.16666 13.3333V3.99999ZM5.83332 5.33332V12H12.5V5.33332H5.83332Z"
					fill={finalColor}
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M17.8333 3.99999C17.8333 3.26361 18.4303 2.66666 19.1666 2.66666H28.5C29.2364 2.66666 29.8333 3.26361 29.8333 3.99999V13.3333C29.8333 14.0697 29.2364 14.6667 28.5 14.6667H19.1666C18.4303 14.6667 17.8333 14.0697 17.8333 13.3333V3.99999ZM20.5 5.33332V12H27.1666V5.33332H20.5Z"
					fill={finalColor}
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M17.8333 18.6666C17.8333 17.9303 18.4303 17.3333 19.1666 17.3333H28.5C29.2364 17.3333 29.8333 17.9303 29.8333 18.6666V28C29.8333 28.7364 29.2364 29.3333 28.5 29.3333H19.1666C18.4303 29.3333 17.8333 28.7364 17.8333 28V18.6666ZM20.5 20V26.6666H27.1666V20H20.5Z"
					fill={finalColor}
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M3.16666 18.6666C3.16666 17.9303 3.76361 17.3333 4.49999 17.3333H13.8333C14.5697 17.3333 15.1667 17.9303 15.1667 18.6666V28C15.1667 28.7364 14.5697 29.3333 13.8333 29.3333H4.49999C3.76361 29.3333 3.16666 28.7364 3.16666 28V18.6666ZM5.83332 20V26.6666H12.5V20H5.83332Z"
					fill={finalColor}
				/>
			</g>
		</svg>
	);
}
export default SvgFiGrid;
